import { useCancelStationaryHold } from 'noddi-web';
import type { PropsWithChildren } from 'react';
import {
  useBookingProposalActions,
  useBookingProposalRecipient,
  useBookingProposalStationaryReservation,
  useBookingProposalUserGroupId
} from '../../stores/bookingProposalStore';
import { ProposalAccessGate } from './ProposalAccessGate';

/** Release a held bay if a different login loses access; preserve the rest of the draft. */
export function BookingProposalAccess({ children }: PropsWithChildren) {
  const userGroupId = useBookingProposalUserGroupId();
  const recipient = useBookingProposalRecipient();
  const hold = useBookingProposalStationaryReservation();
  const { setStationaryReservation } = useBookingProposalActions();
  const { cancelHold } = useCancelStationaryHold();
  return (
    <ProposalAccessGate
      userGroupId={userGroupId}
      recipient={recipient}
      onAccessDenied={() => {
        if (hold) {
          setStationaryReservation(null);
          void cancelHold(hold);
        }
      }}
    >
      {children}
    </ProposalAccessGate>
  );
}
